export const AVAILABLE_LANGUAGES = {
  ES: 'es',
  EN: 'en',
  IT: 'it',
} as const;
